import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F5F5F0' }}>
      <nav className="bg-white border-b border-border shadow-sm">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-3">
              <img src="/assets/logo.png" alt="contractcheck360" className="h-10 w-auto" />
              <span className="text-xl brand-name" style={{ color: '#1A4D2E' }}>contractcheck360</span>
            </Link>
            <Link to="/" className="flex items-center gap-2 text-sm hover:underline" style={{ color: '#1A4D2E' }}>
              <ArrowLeft className="w-4 h-4" /> Volver al inicio
            </Link>
          </div>
        </div>
      </nav>

      <div className="container mx-auto px-4 md:px-8 max-w-4xl py-12">
        <h1 className="text-3xl md:text-4xl font-bold mb-2" style={{ fontFamily: 'Merriweather, serif', color: '#1A4D2E' }}>
          Aviso de Privacidad
        </h1>
        <p className="text-sm mb-8" style={{ color: '#64748B' }}>Última actualización: Diciembre 2025</p>

        <div className="bg-white border border-border rounded-sm p-6 md:p-10 space-y-6" style={{ lineHeight: '1.8' }}>
          
          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>1. Identidad del Responsable</h2>
            <p><strong>ContractCheck360</strong> ("nosotros", "la Plataforma"), con domicilio en Ciudad de México, México, es responsable del tratamiento de sus datos personales conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) y su Reglamento.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>2. Datos Personales Recabados</h2>
            <p>Recabamos los siguientes datos:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Identificación:</strong> nombre completo, correo electrónico.</li>
              <li><strong>Contacto:</strong> dirección de correo electrónico.</li>
              <li><strong>Financieros:</strong> información de pago procesada por Stripe (no almacenamos datos de tarjetas).</li>
              <li><strong>Documentos:</strong> contratos que usted carga para análisis.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>3. Finalidades del Tratamiento</h2>
            <p><strong>Finalidades primarias:</strong></p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Crear y administrar su cuenta de usuario.</li>
              <li>Procesar y analizar los documentos que cargue.</li>
              <li>Procesar pagos por los servicios contratados.</li>
              <li>Generar reportes de análisis.</li>
              <li>Brindar soporte técnico.</li>
            </ul>
            <p className="mt-3"><strong>Finalidades secundarias:</strong></p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Enviar comunicaciones sobre actualizaciones del servicio.</li>
              <li>Realizar estadísticas internas (datos anonimizados).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>4. Transferencia de Datos</h2>
            <p>Sus datos pueden transferirse a:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Amazon Web Services (AWS):</strong> almacenamiento seguro de documentos (servidores en EE.UU.).</li>
              <li><strong>OpenAI:</strong> procesamiento de análisis mediante inteligencia artificial.</li>
              <li><strong>Stripe:</strong> procesamiento de pagos.</li>
            </ul>
            <p className="mt-2">Estas transferencias son necesarias para la prestación del servicio conforme al Art. 37 de la LFPDPPP.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>5. Derechos ARCO</h2>
            <p>Usted tiene derecho a:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li><strong>Acceder</strong> a sus datos personales.</li>
              <li><strong>Rectificar</strong> datos inexactos.</li>
              <li><strong>Cancelar</strong> el tratamiento de sus datos.</li>
              <li><strong>Oponerse</strong> al tratamiento para fines específicos.</li>
            </ul>
            <p className="mt-2">Para ejercer estos derechos, envíe solicitud a: <strong>privacidad@contractcheck360.com</strong></p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>6. Medidas de Seguridad</h2>
            <p>Implementamos medidas técnicas, administrativas y físicas para proteger sus datos, incluyendo:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Cifrado de datos en tránsito (HTTPS/TLS).</li>
              <li>Almacenamiento cifrado en AWS S3.</li>
              <li>Control de acceso basado en roles.</li>
              <li>Tokens de autenticación seguros.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>7. Cookies</h2>
            <p>Utilizamos cookies técnicas esenciales para el funcionamiento del sitio. No utilizamos cookies de rastreo publicitario.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>8. Cambios al Aviso</h2>
            <p>Nos reservamos el derecho de modificar este Aviso. Las modificaciones se publicarán en esta página con la fecha de actualización.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: '#1A4D2E' }}>9. Contacto</h2>
            <p>Para dudas sobre este Aviso de Privacidad:</p>
            <p className="mt-2"><strong>Email:</strong> privacidad@contractcheck360.com</p>
          </section>

          <div className="mt-8 p-4 rounded-sm" style={{ backgroundColor: '#FEF3C7', border: '1px solid #F59E0B' }}>
            <p className="text-sm" style={{ color: '#92400E' }}>
              <strong>Aviso legal:</strong> Este documento es informativo y no constituye asesoría legal. Para cumplimiento específico de la LFPDPPP, consulte a un abogado especializado.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
